import { Link } from '@tanstack/react-router'

import { buttonVariants } from '@/components/ui/button-variants'
import type { SignalStockSource } from '@/screens/signals/SignalStockScreen.loader'

interface SignalStockViewLinkProps {
  /** The view the button opens: the Technicals page, or the Signal page's statistics. */
  to: 'technicals' | 'signal'
  symbol: string
  /** The board the member came from; it travels both ways. */
  from: SignalStockSource
}

/**
 * The button at the right of a stock's header that switches between its two
 * Signal Zone views: "View technicals" on the Signal page, "View signal
 * statistics" on the Technicals page (owner Q5 renamed Figma's "View
 * fundamentals"). A real link, so it opens in a new tab and prefetches.
 */
export default function SignalStockViewLink({ to, symbol, from }: SignalStockViewLinkProps) {
  const className = buttonVariants({ variant: 'secondary' })
  return to === 'technicals' ? (
    <Link
      to="/market/signals/stock/$symbol/technicals"
      params={{ symbol }}
      search={{ from }}
      className={className}
    >
      View technicals
    </Link>
  ) : (
    <Link
      to="/market/signals/stock/$symbol"
      params={{ symbol }}
      search={{ from }}
      className={className}
    >
      View signal statistics
    </Link>
  )
}
